import { RatingInputWUT } from '@wix/form-fields/wut';

export default RatingInputWUT;
